

import { Component } from 'preact';

export default class VideoItem extends Component {

		constructor(props) {
			super(props);
			this.state = { foo: null};
		}

		componentWillMount() {
			let {current} = this.props
			let wistiaVidId = current && current.wistiaVidId
			const script1 = document.createElement("script");
			const script2 = document.createElement("script");

			script1.src = "https://fast.wistia.com/embed/medias/" + wistiaVidId + ".jsonp";
			script1.async = true;

			script2.src = "https://fast.wistia.com/assets/external/E-v1.js";
			script2.async = true;

			document.body.appendChild(script1);
			document.body.appendChild(script2);
		}

		/*
		<div className='col-sm-12' style={{paddingTop: '100%', maxHeight: '260px'}}>
			<div style={{ position: 'absolute', top: 0, right: 0, left:0 , bottom: 0, padding: '10px', maxHeight: '260px'}}>
				<span className={vidClass} style={{ display: 'inline-block', height: '100%', width: '100%', maxHeight: '250px'}} />
			</div>
		</div>
		*/

		render(){
		//ELSE
			let {current} = this.props
			let wistiaVidId = current && current.wistiaVidId
			let videoTitle = current && current.videoTitle ?  current.videoTitle : 'Watch Video'
			let vidClass = "wistia_embed wistia_async_" + wistiaVidId + " popover=true popoverAnimateThumbnail=true"

			return (

				<div className='row' style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>

						<div className='col-xs-10' style={{paddingTop: '100%', maxHeight: '260px'}}>
							<div style={{ position: 'absolute', top: 0, right: 0, left:0 , bottom: 0, padding: '10px', maxHeight: '260px'}}>
								<span className={vidClass} style={{ display: 'inline-block', height: '100%', width: '100%', maxHeight: '250px'}} />
							</div>
						</div>


						<div className='col-sm-12' style={{padding: '0px 5px', display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: '25px' }}>
								<span style={{textAlign:'center'}}>{videoTitle}</span>
						</div>


				</div>

			);
		}
}



// WEBPACK FOOTER //
// ./components/contentTypes/itemCarousel/videoItem.js